import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-polyglot'
import classNames from 'classnames'
import ReactTable from 'react-table'

import './table.scss'

class Table extends PureComponent {
	renderTrGroupComponent = props => <>{props.children}</>

	render() {
		const {
			data,
			columns,
			minRows,
			t,
			scrollOnMobile,
			classNameModifier,
			...rest
		} = this.props

		return (
			<ReactTable
				className={classNames(
					'c-table',
					`c-table--${classNameModifier}`,
					{
						'c-table--scroll-on-mobile': scrollOnMobile,
					}
				)}
				data={data}
				columns={columns}
				showPagination={false}
				defaultPageSize={50}
				minRows={minRows}
				loadingText={t('loading')}
				noDataText={t('no_data_found')}
				resizable={false}
				TrGroupComponent={this.renderTrGroupComponent}
				{...rest}
			/>
		)
	}
}

Table.propTypes = {
	data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
	columns: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object]))
		.isRequired,
	minRows: PropTypes.number,
	scrollOnMobile: PropTypes.bool,
	classNameModifier: PropTypes.string,
}

Table.defaultProps = {
	minRows: 0,
	scrollOnMobile: true,
	classNameModifier: null,
}

export default translate()(Table)
